<template>
	<el-form
		:model="queryParams"
		:rules="rules"
		ref="ruleForm"
		class="demo-ruleForm"
		v-loading="loading"
	>
		<div class="content">
			<p class="text">基本信息</p>
			<el-row type="flex" class="row-bg" justify="space-between">
				<el-col :span="11">
					<el-form-item label="注册号" label-width="50%">
						<el-input
							disabled
							v-model="queryParams.highTechApprovalBO.projectNumber"
							placeholder="自动生成"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="统一社会信用代码"
						prop="highTechApprovalBO.unifySocialCreditCode"
						label-width="50%"
					>
						<el-input
							disabled
							v-model="queryParams.highTechApprovalBO.unifySocialCreditCode"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="企业名称"
						prop="highTechApprovalBO.companyName"
						label-width="50%"
					>
						<el-input
							disabled
							v-model="queryParams.highTechApprovalBO.companyName"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="法人"
						prop="highTechApprovalBO.legalPerson"
						label-width="50%"
					>
						<el-input
							disabled
							v-model="queryParams.highTechApprovalBO.legalPerson"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="注册时间"
						prop="highTechApprovalBO.registTime"
						label-width="50%"
					>
						<el-input
							disabled
							v-model="queryParams.highTechApprovalBO.registTime"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="注册资本"
						prop="highTechApprovalBO.registedCapital"
						label-width="50%"
					>
						<el-input-number
							disabled
							:controls="false"
							v-model="queryParams.highTechApprovalBO.registedCapital"
							placeholder="请输入"
						></el-input-number>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="所属行业"
						prop="highTechApprovalBO.industry"
						label-width="50%"
					>
						<el-input
							disabled
							v-model="queryParams.highTechApprovalBO.industry"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="注册类型"
						prop="highTechApprovalBO.registedType"
						label-width="50%"
					>
						<el-select v-model="queryParams.highTechApprovalBO.registedType">
							<el-option
								v-for="dict in enterpriseRegistrationType"
								:key="dict.id"
								:label="dict.dictName"
								:value="dict.dictCode"
								placeholder="请选择"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<!-- <el-col :span="11">
            <el-form-item label="项目编号" prop="highTechApprovalBO.projectNumber" label-width="50%">
              <el-input v-model="queryParams.highTechApprovalBO.projectNumber" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col> -->

				<el-col :span="11">
					<el-form-item
						label="外资来源"
						prop="highTechApprovalBO.foreignSource"
						label-width="50%"
					>
						<el-select v-model="queryParams.highTechApprovalBO.foreignSource">
							<el-option
								v-for="dict in foreignCapitalSource"
								:key="dict.id"
								:label="dict.dictName"
								:value="dict.dictCode"
								placeholder="请选择"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item label="所属区域" label-width="50%" prop="area">
						<el-cascader
							:options="options"
							:clearable="false"
							:disabled="areaDisabled"
							v-model="queryParams.area"
							:placeholder="areaPlaceholder"
							@change="areaChange()"
						></el-cascader>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="是否属于国家级高新区内企业"
						prop="highTechApprovalBO.isNationalLevel"
						label-width="50%"
					>
						<el-select
							v-model="queryParams.highTechApprovalBO.isNationalLevel"
							placeholder="是"
						>
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						v-if="queryParams.highTechApprovalBO.isNationalLevel == 1"
						label="高新区名称"
						prop="highTechApprovalBO.highTechAreaName"
						label-width="50%"
					>
						<el-input
							v-model="queryParams.highTechApprovalBO.highTechAreaName"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="企业所得税征收方式"
						prop="highTechApprovalBO.taxCollectionMethod"
						label-width="50%"
					>
						<el-select
							v-model="queryParams.highTechApprovalBO.taxCollectionMethod"
						>
							<el-option
								v-for="dict in enterpriseIncomeTaxCollectionMethod"
								:key="dict.id"
								:label="dict.dictName"
								:value="dict.dictCode"
								placeholder="请选择"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="企业规模"
						prop="highTechApprovalBO.companyScale"
						label-width="50%"
					>
						<el-select v-model="queryParams.highTechApprovalBO.companyScale">
							<el-option
								v-for="dict in enterpriseScale"
								:key="dict.id"
								:label="dict.dictName"
								:value="dict.dictCode"
								placeholder="请选择"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="邮政编码"
						prop="highTechApprovalBO.postalCode"
						label-width="50%"
					>
						<el-input
							v-model="queryParams.highTechApprovalBO.postalCode"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item
						label="通信地址"
						prop="highTechApprovalBO.address"
						label-width="23%"
					>
						<el-input
							:maxlength="inputMax"
							v-model="queryParams.highTechApprovalBO.address"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</div>

		<div class="content">
			<p class="text">联系人信息</p>
			<el-row type="flex" class="row-bg" justify="space-between">
				<el-col :span="11">
					<el-form-item
						label="姓名"
						prop="linkmanBO.linkmanName"
						label-width="50%"
					>
						<el-input
							:maxlength="nameMax"
							v-model="queryParams.linkmanBO.linkmanName"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="手机"
						prop="linkmanBO.linkmanMobile"
						label-width="50%"
					>
						<el-input-number
							:controls="false"
							v-model="queryParams.linkmanBO.linkmanMobile"
							placeholder="请填写"
						></el-input-number>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="电话"
						prop="linkmanBO.linkmanPhone"
						label-width="50%"
					>
						<el-input
							v-model="queryParams.linkmanBO.linkmanPhone"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="传真"
						prop="linkmanBO.linkmanFax"
						label-width="50%"
					>
						<el-input
							v-model="queryParams.linkmanBO.linkmanFax"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="EMALL"
						prop="linkmanBO.linkmanMail"
						label-width="50%"
					>
						<el-input
							:maxlength="emailMax"
							v-model="queryParams.linkmanBO.linkmanMail"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</div>

		<div class="content">
			<p class="text">企业法人信息</p>
			<el-row type="flex" class="row-bg" justify="space-between">
				<el-col :span="11">
					<el-form-item
						label="姓名"
						prop="legalPersonBO.linkmanName"
						label-width="40%"
					>
						<el-input
							:maxlength="nameMax"
							v-model="queryParams.legalPersonBO.linkmanName"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="手机"
						prop="legalPersonBO.linkmanMobile"
						label-width="40%"
					>
						<el-input-number
							:controls="false"
							v-model="queryParams.legalPersonBO.linkmanMobile"
							placeholder="请输入"
						></el-input-number>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="电话"
						prop="legalPersonBO.linkmanPhone"
						label-width="40%"
					>
						<el-input
							v-model="queryParams.legalPersonBO.linkmanPhone"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="EMALL"
						prop="legalPersonBO.linkmanMail"
						label-width="40%"
					>
						<el-input
							:maxlength="emailMax"
							v-model="queryParams.legalPersonBO.linkmanMail"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</div>

		<div class="content">
			<p class="text">技术领域</p>
			<el-row type="flex" class="row-bg" justify="space-between">
				<el-col :span="24">
					<el-form-item label="技术领域" :required="true" label-width="18%">
						<div class="select_box">
							<el-form-item prop="highTechApprovalBO.tecFieldFirst">
								<el-select
									v-model="queryParams.highTechApprovalBO.tecFieldFirst"
									@change="tecFieldCchange"
								>
									<el-option
										v-for="dict in tecFieldFirst"
										:key="dict.id"
										:label="dict.dictName"
										:value="dict.dictCode"
										placeholder="请选择"
									></el-option>
								</el-select>
							</el-form-item>

							<el-form-item prop="highTechApprovalBO.tecFieldSecond">
								<el-select
									v-model="queryParams.highTechApprovalBO.tecFieldSecond"
									@change="tecFieldSecondCchange"
								>
									<el-option
										v-for="dict in tecFieldSecond"
										:key="dict.id"
										:label="dict.dictName"
										:value="dict.dictCode"
										placeholder="请选择"
									></el-option>
								</el-select>
							</el-form-item>

							<el-form-item prop="highTechApprovalBO.tecFieldThird">
								<el-select
									v-model="queryParams.highTechApprovalBO.tecFieldThird"
								>
									<el-option
										v-for="dict in tecFieldThird"
										:key="dict.id"
										:label="dict.dictName"
										:value="dict.dictCode"
										placeholder="请选择"
									></el-option>
								</el-select>
							</el-form-item>
						</div>
					</el-form-item>
				</el-col>

				<el-col :span="11">
					<el-form-item
						label="是否上市"
						prop="highTechApprovalBO.isMarket"
						label-width="40%"
					>
						<el-select
							v-model="queryParams.highTechApprovalBO.isMarket"
							@change="markerChange"
							placeholder="是"
						>
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-col>

				<el-col :span="11" v-if="queryParams.highTechApprovalBO.isMarket == 1">
					<el-form-item
						label="上市类型"
						prop="highTechApprovalBO.marketType"
						label-width="40%"
					>
						<el-select v-model="queryParams.highTechApprovalBO.marketType">
							<el-option
								v-for="dict in listingType"
								:key="dict.id"
								:label="dict.dictName"
								:value="dict.dictCode"
								placeholder="请选择"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="11" v-if="queryParams.highTechApprovalBO.isMarket == 1">
					<el-form-item
						label="上市时间"
						prop="highTechApprovalBO.marketTime"
						label-width="40%"
					>
						<el-date-picker
							:editable="false"
							value-format="yyyy-MM-dd"
							:picker-options="pickerOptions"
							v-model="queryParams.highTechApprovalBO.marketTime"
							placeholder="请选择"
						></el-date-picker>
					</el-form-item>
				</el-col>

				<el-col :span="11" v-if="queryParams.highTechApprovalBO.isMarket == 1">
					<el-form-item
						label="股票代码"
						prop="highTechApprovalBO.stockCode"
						label-width="40%"
					>
						<el-input
							:maxlength="inputMax"
							v-model="queryParams.highTechApprovalBO.stockCode"
							placeholder="请填写"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>

			<div class="wrap">
				<!-- 股权结构 -->
				<div class="border_box">
					<p style="color: #787878" class="flex flex-justify pp">
						<span>股权结构</span>
					</p>
					<i
						class="gsadd el-icon-circle-plus-outline"
						style="color:red;"
						@click="grAdd"
					></i>
					<el-table
						class="table"
						:data="queryParams.highTechApprovalEquityStructurePersonBOList"
						:header-cell-style="{ background: '#ccc' }"
						:row-class-name="tableRowClassName"
					>
						<el-table-column width="55" label="">
							<template slot-scope="scope">
								<i
									class="el-icon-remove"
									@click="grDelete(scope.$index)"
									style="color:#747474;"
								></i>
							</template>
						</el-table-column>
						<el-table-column label="个人股东" width="" prop="date">
							<template slot-scope="scope">
								<el-select v-model="scope.row.citizenType">
									<el-option
										v-for="dict in citizenType"
										:key="dict.dictCode"
										:label="dict.dictName"
										:value="dict.dictCode"
										placeholder="请选择"
									></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="citizenName" label="姓名" width="260">
							<template slot-scope="scope">
								<el-form-item
									label=""
									:prop="
										'highTechApprovalEquityStructurePersonBOList.' +
											scope.$index +
											'.citizenName'
									"
									:rules="
										rules.highTechApprovalEquityStructurePersonBOListCitizenName
									"
									style="margin-bottom:0px;"
								>
									<el-input
										:maxlength="nameMax"
										v-model="scope.row.citizenName"
									></el-input>
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column prop="idNumber" label="身份证（护照号）" width="">
							<template slot-scope="scope">
								<el-form-item
									label=""
									:prop="
										'highTechApprovalEquityStructurePersonBOList.' +
											scope.$index +
											'.idNumber'
									"
									:rules="
										rules.highTechApprovalEquityStructurePersonBOListIdNumber
									"
									style="margin-bottom:0px;"
								>
									<el-input
										:maxlength="inputMax"
										v-model="scope.row.idNumber"
									></el-input>
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column
							label="投资额（万元）"
							width="150"
							prop="investmentVolume"
						>
							<template slot-scope="scope">
								<el-input-number
									:max="99999999999999"
									:controls="false"
									v-model="scope.row.investmentVolume"
								></el-input-number>
							</template>
						</el-table-column>
					</el-table>
					<div class="border_box2">
						<i
							class="gsadd el-icon-circle-plus-outline"
							style="color: red"
							@click="gsAdd"
						></i>
						<el-table
							class="table"
							:data="queryParams.techApprovalEquityStructureCompanyBOList"
							:header-cell-style="{ background: '#ccc' }"
							:row-class-name="tableRowClassName"
						>
							<el-table-column width="55" label="">
								<template slot-scope="scope">
									<i
										class="el-icon-remove"
										@click="gsDelete(scope.$index)"
										style="color: #747474"
									></i>
								</template>
							</el-table-column>
							<el-table-column
								label="法人类型（法人股东）"
								width="legalPersonType"
								prop="date"
							>
								<template slot-scope="scope">
									<el-select v-model="scope.row.legalPersonType">
										<el-option
											v-for="dict in legalPersonType"
											:key="dict.dictCode"
											:label="dict.dictName"
											:value="dict.dictCode"
											placeholder="请选择"
										></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column prop="companyName" label="名称" width="260">
								<template slot-scope="scope">
									<el-form-item
										label=""
										:prop="
											'techApprovalEquityStructureCompanyBOList.' +
												scope.$index +
												'.companyName'
										"
										:rules="
											rules.techApprovalEquityStructureCompanyBOListCompanyName
										"
										style="margin-bottom:0px;"
									>
										<el-input
											:maxlength="nameMax"
											v-model="scope.row.companyName"
										></el-input>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column
								prop="address"
								label="组织机构代码或统一社会信用代码"
								width="orgCode"
							>
								<template slot-scope="scope">
									<el-form-item
										label=""
										:prop="
											'techApprovalEquityStructureCompanyBOList.' +
												scope.$index +
												'.orgCode'
										"
										:rules="
											rules.techApprovalEquityStructureCompanyBOListOrgCode
										"
										style="margin-bottom:0px;"
									>
										<el-input v-model="scope.row.orgCode"></el-input>
									</el-form-item>
								</template>
							</el-table-column>
							<el-table-column
								label="投资额（万元）"
								width="150"
								prop="investmentVolume"
							>
								<template slot-scope="scope">
									<el-input-number
										:controls="false"
										v-model="scope.row.investmentVolume"
										:max="99999999999999"
									></el-input-number>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<div class="border_box">
					<p style="color: #787878" class="flex flex-justify pp">
						<span>风险投资</span>
					</p>
					<i
						class="gsadd el-icon-circle-plus-outline"
						style="color:red;"
						@click="fxAdd"
					></i>
					<el-table
						class="table"
						:data="queryParams.risk"
						:header-cell-style="{ background: '#ccc' }"
						:row-class-name="tableRowClassName"
					>
						<el-table-column width="55" label="">
							<template slot-scope="scope">
								<i
									class="el-icon-remove"
									@click="fxDelete(scope.$index)"
									style="color:#747474;"
								></i>
							</template>
						</el-table-column>
						<el-table-column
							label="法人类型"
							width="legalPersonType"
							prop="date"
						>
							<template slot-scope="scope">
								<el-select v-model="scope.row.legalPersonType">
									<el-option
										v-for="dict in legalPersonType"
										:key="dict.dictCode"
										:label="dict.dictName"
										:value="dict.dictCode"
										placeholder="请选择"
									></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="companyName" label="名称" width="260">
							<template slot-scope="scope">
								<el-form-item
									label=""
									:prop="'risk.' + scope.$index + '.companyName'"
									:rules="rules.riskCompanyName"
									style="margin-bottom:0px;"
								>
									<el-input
										:maxlength="nameMax"
										v-model="scope.row.companyName"
									></el-input>
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column
							prop="orgCode"
							label="组织机构代码或统一社会信用代码"
						>
							<template slot-scope="scope">
								<el-form-item
									label=""
									:prop="'risk.' + scope.$index + '.orgCode'"
									:rules="rules.riskOrgCode"
									style="margin-bottom:0px;"
								>
									<el-input
										:maxlength="inputMax"
										v-model="scope.row.orgCode"
									></el-input>
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column
							label="投资额（万元）"
							width="150"
							prop="investmentVolume"
						>
							<template slot-scope="scope">
								<el-input-number
									:controls="false"
									v-model="scope.row.investmentVolume"
									:max="99999999999999"
								></el-input-number>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<div>
					<p style="color: #787878">经营范围(限400字以内)</p>
					<el-input
						type="textarea"
						maxlength="400"
						:rows="5"
						show-word-limit
						v-model="queryParams.highTechApprovalBO.businessScope"
					></el-input>
				</div>
				<div>
					<p style="color: #787878">企业简介(限400字以内)</p>
					<el-input
						type="textarea"
						maxlength="400"
						:rows="5"
						show-word-limit
						v-model="queryParams.highTechApprovalBO.companyIntroduce"
					></el-input>
				</div>
				<br />
			</div>
		</div>

		<el-row type="flex" justify="center" class="button_box">
			<el-col :span="6">
				<el-button type="primary" @click="backHomepage()">返回</el-button>
			</el-col>
			<el-col :span="6">
				<el-button type="primary" @click="classSubmitForm(1)">保存</el-button>
			</el-col>
			<el-col :span="6">
				<el-tooltip class="item" effect="light" content="操作点击上方步骤导航栏可跳转至对应页面填写信息" placement="top">
					<el-button round @click="classSubmitForm(2)">下一步</el-button>
				</el-tooltip>
			</el-col>
		</el-row>
	</el-form>
</template>

<script>
import {
	getDict,
	queryDictDataByTypeAndCode,
	getDistrictByParentId,
	getDistricts,
	getDistrictByKey,
	enterpriseInformationRegisterQuery,
	enterpriseInformationRegisterSave
} from "@/api/ChinaHigh";
import { Message } from "element-ui";
import { commonGetCompanyInfo } from "@/api/toolCommon";

export default {
	/*    beforeDestroy() {
        this.classSubmitForm(3);
    },*/
	name: "registrationForm",
	props: {
		id: {
			type: String,
			default: ""
		}
	},
	data() {
		var validateIdNumber = (rule, value, callback) => {
			if (
				!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value) &&
				!/^((1[45]\d{7})|(G\d{8})|(P\d{7})|(S\d{7,8}))?$/.test(value)
			) {
				callback(new Error("身份证号或护照号不正确！"));
			}
			callback();
		};
		return {
			loading: false,
			areaDisabled: true,
			areaPlaceholder: "正在加载数据",
			queryParams: {
				highTechApprovalBO: {
					companyName: "",
					id: "",
					isMarket: 1
				},
				area: [],
				highTechApprovalEquityStructurePersonBOList: [],
				techApprovalEquityStructureCompanyBOList: [],
				linkmanBO: {},
				legalPersonBO: {},
				risk: []
			},
			rules: {},
			jcRules: {
				"highTechApprovalBO.companyName": [
					{ required: true, message: "请输入公司名称", trigger: "blur" }
				],
				"highTechApprovalBO.unifySocialCreditCode": [
					{ required: true, message: "请输入统一社会信用代码", trigger: "blur" }
				],
				"highTechApprovalBO.legalPerson": [
					{ required: true, message: "请输入法人", trigger: "blur" }
				],
				"highTechApprovalBO.industry": [
					{ required: true, message: "请输入所属行业", trigger: "blur" }
				],
				"highTechApprovalBO.registTime": [
					{ required: true, message: "请选择注册日期", trigger: "change" }
				],
				"highTechApprovalBO.registedCapital": [
					{ required: true, message: "请输入注册资金", trigger: "blur" }
				],
				"highTechApprovalBO.registedType": [
					{ required: true, message: "请输入注册类型", trigger: "change" }
				],
				"highTechApprovalBO.projectNumber": [
					{ required: true, message: "请输入项目编号", trigger: "change" }
				],
				"highTechApprovalBO.foreignSource": [
					{ required: true, message: "请选择外资来源", trigger: "change" }
				],
				"highTechApprovalBO.isNationalLevel": [
					{
						required: true,
						message: "请选择是否属于国家级高新区内企业",
						trigger: "change"
					}
				],
				// 'highTechApprovalBO.highTechAreaName': [ {required: true, message: "请输入高新区名称", trigger: "blur"} ],
				"highTechApprovalBO.companyScale": [
					{ required: true, message: "请选择企业规模", trigger: "change" }
				],
				"highTechApprovalBO.taxCollectionMethod": [
					{
						required: true,
						message: "请选择企业所得税征收方式",
						trigger: "change"
					}
				],
				area: [
					{ required: true, message: "请选择所属区域", trigger: "change" }
				],
				"highTechApprovalBO.province": [
					{ required: true, message: "请选择省", trigger: "change" }
				],
				"highTechApprovalBO.city": [
					{ required: true, message: "请选择市", trigger: "change" }
				],
				"highTechApprovalBO.counties": [
					{ required: true, message: "请选择区", trigger: "change" }
				],
				"highTechApprovalBO.address": [
					{ required: true, message: "请输入通信地址", trigger: "blur" }
				],
				"highTechApprovalBO.postalCode": [
					{ required: true, message: "请输入邮政编码", trigger: "blur" }
				],
				"linkmanBO.linkmanName": [
					{ required: true, message: "请输入姓名", trigger: "blur" }
				],
				"linkmanBO.linkmanMobile": [
					{ required: true, message: "请输入手机", trigger: "blur" },
					{
						pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
						message: "请输入正确的手机号码",
						trigger: "blur"
					}
				],
				"linkmanBO.linkmanPhone": [
					{ required: true, message: "请输入电话", trigger: "blur" },
					{
						pattern: /^([0-9]{3,4}-)?[0-9]{7,8}$/,
						message: "请输入正确的电话",
						trigger: "blur"
					}
				],
				"linkmanBO.linkmanFax": [
					{ required: true, message: "请输入传真", trigger: "blur" },
					{
						pattern: /^(\d{3,4}-)?\d{7,8}$/,
						message: "请输入正确的传真",
						trigger: "blur"
					}
				],
				"linkmanBO.linkmanMail": [
					{ required: true, message: "请输入EMALL", trigger: "blur" },
					{
						pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
						message: "请输入正确的EMALL",
						trigger: "blur"
					}
				],
				"legalPersonBO.linkmanName": [
					{ required: true, message: "请输入姓名", trigger: "blur" }
				],
				"legalPersonBO.linkmanMobile": [
					{ required: true, message: "请输入手机", trigger: "blur" },
					{
						pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
						message: "请输入正确的手机号码",
						trigger: "blur"
					}
				],
				"legalPersonBO.linkmanPhone": [
					{ required: true, message: "请输入电话", trigger: "blur" },
					{
						pattern: /^([0-9]{3,4}-)?[0-9]{7,8}$/,
						message: "请输入正确的电话",
						trigger: "blur"
					}
				],
				"legalPersonBO.linkmanMail": [
					{ required: true, message: "请输入EMALL", trigger: "blur" },
					{
						pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
						message: "请输入正确的EMALL",
						trigger: "blur"
					}
				],
				"highTechApprovalBO.tecFieldFirst": [
					{ required: true, message: "请选择技术领域", trigger: "change" }
				],
				"highTechApprovalBO.tecFieldSecond": [
					{ required: true, message: "请选择技术领域", trigger: "change" }
				],
				"highTechApprovalBO.tecFieldThird": [
					{ required: true, message: "请选择技术领域", trigger: "change" }
				],
				"highTechApprovalBO.isMarket": [
					{ required: true, message: "请选择是否上市", trigger: "change" }
				],
				highTechApprovalEquityStructurePersonBOListCitizenName: [
					{ required: true, message: "请输入姓名", trigger: "blur" }
				],
				highTechApprovalEquityStructurePersonBOListIdNumber: [
					{ validator: validateIdNumber, trigger: "blur" }
				],
				techApprovalEquityStructureCompanyBOListCompanyName: [
					{ required: true, message: "请输入姓名", trigger: "blur" }
				],
				techApprovalEquityStructureCompanyBOListOrgCode: [
					{
						required: true,
						message: "请输入组织机构代码或统一社会信用代码",
						trigger: "blur"
					}
				],
				riskCompanyName: [
					{ required: true, message: "请输入名称", trigger: "blur" }
				],
				riskOrgCode: [
					{
						required: true,
						message: "请输入组织机构代码或统一社会信用代码",
						trigger: "blur"
					}
				]
			},
			gqRules: {
				"highTechApprovalBO.marketType": [
					{ required: true, message: "请选择上市类型", trigger: "change" }
				],
				"highTechApprovalBO.marketTime": [
					{ required: true, message: "请选择上市时间", trigger: "change" }
				],
				"highTechApprovalBO.stockCode": [
					{ required: true, message: "请输入股票代码", trigger: "blur" }
				]
			},
			// 企业规模
			enterpriseScale: [],
			// 外资来源
			foreignCapitalSource: [],
			// 上市类型
			listingType: [],
			// 注册类型
			enterpriseRegistrationType: [],
			// 企业所得税征收方式
			enterpriseIncomeTaxCollectionMethod: [],
			// 技术领域1
			tecFieldFirst: [],
			// 技术领域2
			tecFieldSecond: [],
			// 技术领域3
			tecFieldThird: [],
			// 省
			province: [],
			// 市
			city: [],
			// 区
			counties: [],
			//日期限制
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6;
				}
			},
			// 法人类型
			legalPersonType: [],
			citizenType: [
				{ dictCode: 1, dictName: "中国企业法人" },
				{ dictCode: 2, dictName: "外国企业法人" }
			],

			options: [
				{
					value: "sheng",
					label: "数据加载中...",
					children: [
						{
							value: "shi",
							label: "数据加载中",
							children: [
								{
									value: "qu",
									label: "数据加载中"
								}
							]
						}
					]
				}
			]
		};
	},
	created() {
		let id = this.$route.query.id;
		Object.assign(this.rules, this.jcRules, this.gqRules);
		if (id !== undefined) {
			this.shuju(id);
		} else if (this.id !== "" && this.id !== undefined && this.id !== null) {
			this.shuju(this.id);
		} else {
			// this.qy();
			this.shuju("0");
		}
		this.chushi();
	},
	methods: {
		areaChange() {
			if (this.queryParams.area.length <= 0) {
				this.queryParams.highTechApprovalBO.province = "";
				this.queryParams.highTechApprovalBO.city = "";
				this.queryParams.highTechApprovalBO.counties = "";
			} else {
				this.queryParams.highTechApprovalBO.province = this.queryParams.area[0];
				this.queryParams.highTechApprovalBO.city = this.queryParams.area[1];
				this.queryParams.highTechApprovalBO.counties = this.queryParams.area[2];
			}
		},
		tableRowClassName({ row, rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return "background:#fff";
			} else {
				return "background:#F5F7FA";
			}
		},
		qy() {
			commonGetCompanyInfo().then(res => {
				this.queryParams.highTechApprovalBO = {
					companyName: res.data.name,
					unifySocialCreditCode: res.data.org_number,
					legalPerson: res.data.legal_person_name,
					industry: res.data.cate_3,
					registTime:
						new Date(res.data.approved_time).getFullYear() +
						"-" +
						(new Date(res.data.approved_time).getMonth() + 1 >= 10
							? new Date(res.data.approved_time).getMonth() + 1
							: "0" + (new Date(res.data.approved_time).getMonth() + 1)) +
						"-" +
						(new Date(res.data.approved_time).getDate() >= 10
							? new Date(res.data.approved_time).getDate()
							: "0" + new Date(res.data.approved_time).getDate()),
					registedCapital: res.data.reg_capital
				};

				 this.$nextTick(() => {
							this.$refs["ruleForm"].clearValidate();
					});
			});
		},
		shuju(id) {
			enterpriseInformationRegisterQuery(id).then(res => {
				 if (res.data.highTechApprovalBO){
              if(res.data.highTechApprovalBO.tecFieldFirst !== '' && res.data.highTechApprovalBO.tecFieldFirst !== null) {
                  this.jishu(res.data.highTechApprovalBO.tecFieldFirst,1,2);
              }
              if(res.data.highTechApprovalBO.tecFieldSecond !== '' && res.data.highTechApprovalBO.tecFieldSecond !== null) {
                  this.jishu(res.data.highTechApprovalBO.tecFieldSecond,2,2);
              }
              if(this.queryParams.highTechApprovalBO.isMarket !== 1) {
                  this.rules = this.jcRules
              }
              this.queryParams=res.data;
              console.log(this.queryParams);
              this.queryParams.area=[res.data.highTechApprovalBO.province,res.data.highTechApprovalBO.city,res.data.highTechApprovalBO.counties]
          }else{
              this.qy();
          }
				// this.queryParams.area.push(res.data.highTechApprovalBO.province);
				// this.queryParams.area.push(res.data.highTechApprovalBO.city);
				// this.queryParams.area.push(res.data.highTechApprovalBO.counties);
			});
		},
		chushi() {
			// 企业规模
			getDict({ type: "enterprise_scale" }).then(res => {
				this.enterpriseScale = res.data;
			});
			// 外资来源
			getDict({ type: "foreign_capital_source" }).then(res => {
				this.foreignCapitalSource = res.data;
			});
			// 上市类型
			getDict({ type: "listing_type" }).then(res => {
				this.listingType = res.data;
			});
			// 注册类型
			getDict({ type: "enterprise_registration_type" }).then(res => {
				this.enterpriseRegistrationType = res.data;
			});
			// 企业所得税征收方式
			getDict({ type: "enterprise_income_tax_collection_method" }).then(res => {
				this.enterpriseIncomeTaxCollectionMethod = res.data;
			});
			// 技术领域1
			getDict({ type: "technical_field", parentId: 0 }).then(res => {
				this.tecFieldFirst = res.data;
			});
			/*      //省
      getDistrictByParentId({ 'parentId': 0 }).then(res => {
        console.log(res.data);
        this.province = res.data;
      })*/
			//获取地区级联数据
			getDistricts().then(res => {
				this.options = res.data;
				this.areaDisabled = false;
				this.areaPlaceholder = "请选择省市区";
			}),
				// 法人类型
				getDict({ type: "legal_person_type", parentId: 0 }).then(res => {
					this.legalPersonType = res.data;
				});
		},
		backHomepage(){
            //this.$router.push('/form/apply/index')
            this.$router.push('apply')
        },
		classSubmitForm(status) {
			console.log(this.queryParams);
			this.loading = true;
			this.$refs["ruleForm"].validate(valid => {
				if (valid) {
					if (this.queryParams.highTechApprovalBO.isMarket !== 1) {
						this.queryParams.highTechApprovalBO.marketType = "";
						this.queryParams.highTechApprovalBO.marketTime = "";
						this.queryParams.highTechApprovalBO.stockCode = "";
					}
					enterpriseInformationRegisterSave(this.queryParams).then(res => {
						this.loading = false;
						if (res.code === "00000") {
							this.shuju(res.data);
							Message({
								message: res.msg,
								type: "success"
							});
							this.$emit("ok", res.data);
							if (status === 2) {
								this.$emit("step", 2);
							}
							let path = this.$router.history.current.path;
							this.$router.push({ path, query: { id: res.data } });
						}
					});
				} else {
					this.loading = false;
				}
			});
		},
		tecFieldCchange(val) {
			this.jishu(val, 1, 1);
		},
		tecFieldSecondCchange(val) {
			this.jishu(val, 2, 1);
		},
		// 技术领域
		jishu(val, type, stauts) {
			queryDictDataByTypeAndCode({ code: val, type: "technical_field" }).then(
				res => {
					if (type == 1) {
						if (stauts == 1) {
							this.tecFieldThird = {};
							this.$set(
								this.queryParams.highTechApprovalBO,
								"tecFieldSecond",
								""
							);
							this.$set(
								this.queryParams.highTechApprovalBO,
								"tecFieldThird",
								""
							);
						}
						this.tecFieldSecond = res.data;
					} else {
						if (stauts == 1) {
							this.$set(
								this.queryParams.highTechApprovalBO,
								"tecFieldThird",
								""
							);
						}
						this.tecFieldThird = res.data;
					}
				}
			);
		},
		provinceCchange(val) {
			this.quyu(val, 1, 1);
		},
		cityCchange(val) {
			this.quyu(val, 2, 1);
		},
		// 区域
		quyu(val, type, stauts) {
			getDistrictByKey({ key: val }).then(res => {
				if (type == 1) {
					if (stauts == 1) {
						this.counties = {};
						this.$set(this.queryParams.highTechApprovalBO, "city", "");
						this.$set(this.queryParams.highTechApprovalBO, "counties", "");
					}
					this.city = res.data;
				} else {
					if (stauts == 1) {
						this.$set(this.queryParams.highTechApprovalBO, "counties", "");
					}
					this.counties = res.data;
				}
			});
		},
		grAdd() {
			this.queryParams.highTechApprovalEquityStructurePersonBOList.push({
				citizenType: 1,
				citizenName: "",
				idNumber: "",
				investmentVolume: ""
			});
		},
		grDelete(index) {
			var highTechApprovalEquityStructurePersonBOList = JSON.parse(
				JSON.stringify(
					this.queryParams.highTechApprovalEquityStructurePersonBOList
				)
			);
			highTechApprovalEquityStructurePersonBOList.splice(index, 1);
			this.queryParams.highTechApprovalEquityStructurePersonBOList = highTechApprovalEquityStructurePersonBOList;
		},
		gsAdd() {
			this.queryParams.techApprovalEquityStructureCompanyBOList.push({
				legalPersonType: 1,
				companyName: "",
				orgCode: "",
				investmentVolume: ""
			});
		},
		gsDelete(index) {
			var techApprovalEquityStructureCompanyBOList = JSON.parse(
				JSON.stringify(
					this.queryParams.techApprovalEquityStructureCompanyBOList
				)
			);
			techApprovalEquityStructureCompanyBOList.splice(index, 1);
			this.queryParams.techApprovalEquityStructureCompanyBOList = techApprovalEquityStructureCompanyBOList;
		},
		fxAdd() {
			this.queryParams.risk.push({
				legalPersonType: 1,
				companyName: "",
				orgCode: "",
				investmentVolume: ""
			});
		},
		fxDelete(index) {
			var techApprovalEquityStructureCompanyBOList = JSON.parse(
				JSON.stringify(this.queryParams.risk)
			);
			techApprovalEquityStructureCompanyBOList.splice(index, 1);
			this.queryParams.risk = techApprovalEquityStructureCompanyBOList;
		},
		markerChange(val) {
			if (val == 1) {
				Object.assign(this.rules, this.jcRules, this.gqRules);
			} else {
				this.rules = this.jcRules;
			}
		}
	}
};
</script>

<style scoped>
.flex .el-button {
	margin-bottom: 10px;
}

.button_box {
	margin-top: 20px;
}

.button_box button {
	padding: 10px 60px;
}

.image {
	width: 100%;
	height: auto;
}

.select_box {
	/* display: -webkit-box; */
	display: flex;
	justify-content: space-between;
	width: 100%;
}

.textarea {
	width: 90%;
	height: 164px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	resize: none;
}

.wrap {
	width: 84%;
	margin-left: 16%;
}

.row-bg {
	width: 84%;
	margin: 0 auto;
	flex-wrap: wrap;
}

.content {
	margin-top: 30px;
	background: #fff;
	width: 100%;
}

.content .text {
	font-size: 13px;
	padding: 10px 20px;
	border-bottom: 1px solid #d4d4d4;
	position: relative;
}
.border_box {
	position: relative;
	border: 1px solid #dbdbdb;
	margin: 20px 20px 20px 0;
	padding: 10px;
}
.border_box2 {
	position: relative;
	margin-top: 20px;
}
.content .text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 10px;
	background: #7c99fd;
}

.el-table .cell {
	white-space: pre-line;
}

.el-input-number,
.el-date-picker,
.el-select,
.el-date-editor,
.el-cascader {
	width: 100%;
}
.pp img {
	width: 15px;
	height: 15px;
}
.border_box .gsadd {
	position: absolute;
	left: 27px;
	top: 80px;
	z-index: 9;
}
.border_box2 .gsadd {
	position: absolute;
	left: 15px;
	top: 17px;
	z-index: 9;
}
</style>
